export enum PhoneType {
  OFFICE = 'office',
  MOBILE = 'mobile',
}
